var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect, _rect2, _circle, _path23, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _path24, _rect59, _rect60, _circle2, _circle3, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _path25, _rect183, _rect184, _circle4, _rect185, _circle5, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _path26, _path27, _path28, _path29, _path30, _path31, _polygon, _polygon2, _path32, _path33, _path34, _path35, _polygon3, _path36, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _path37, _path38, _path39, _path40, _path41, _path42, _circle6, _circle7, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _g2, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _ellipse2, _ellipse3, _g3, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _path64, _path65, _path66, _path67, _circle8, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _circle9, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _path89, _path90, _path91, _path92, _g4, _path93, _path94;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileTabLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "50c1f3d6-3596-4f78-a680-84ef08523434",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1086.82,
    height: 789.35,
    viewBox: "0 0 1086.82 789.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "22371c7b-1b7b-4aab-a60b-8a215b8ce92d",
    x1: 687.58,
    y1: 652.36,
    x2: 687.58,
    y2: 167.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d4a1e37c-1d20-4442-be38-826149171c3f",
    x1: 357.66,
    y1: 752.53,
    x2: 357.66,
    y2: 310.18,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "52583eb6-2034-4198-bc7c-1e2be9031359",
    x1: 211.31,
    y1: 788.29,
    x2: 211.31,
    y2: 442.62,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a16bfa34-d1a3-4472-9999-21ee7545ab3e",
    x1: 462.24,
    y1: 798.83,
    x2: 462.24,
    y2: 605.67,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "acc52bd5-c2c3-4362-a9d1-2a5a10558a32",
    x1: 382.57,
    y1: 625.81,
    x2: 473.48,
    y2: 625.81,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c79e9d42-5070-416c-b31a-75c30b54975b",
    x1: 513.42,
    y1: 844.47,
    x2: 513.42,
    y2: 415.5,
    gradientTransform: "matrix(-1, 0, 0, 1, 825.97, 0)",
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d299ef7c-b001-4b07-9539-ad7dec3d5c28",
    x1: 203.72,
    y1: 516.5,
    x2: 203.72,
    y2: 437.56,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "48518945-bf04-4db7-b147-76b4ac12eaa6",
    x1: 1061.94,
    y1: 708.58,
    x2: 1061.94,
    y2: 289.15,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd1dbd67-1519-4b37-9c1d-ca278a6685f4",
    x1: 917.3,
    y1: 444.63,
    x2: 917.3,
    y2: 300.43,
    xlinkHref: "#22371c7b-1b7b-4aab-a60b-8a215b8ce92d"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "in sync") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210,98.74c-8.06-.23-16.32,0-23.88,2.32-20.57,6.32-30.32,27-27.15,44.87s16.21,33.44,29.74,47.67,28.19,28.3,35.61,45.31c3.7,8.49,5.43,18,1.67,26.48-5.8,13.07-23.29,20.37-40.08,21.89s-33.65-1.44-50.5-2.43c-7.07-.41-14.34-.46-21,1.45-7.31,2.08-13.4,6.33-19,10.76C73.52,314.42,56,338.13,58.86,363c3.2,28.23,31.74,50.54,63,62.51,10.35,4,21.3,7.18,30.41,12.84,24,14.93,29.39,42.93,27,67.64s-10.53,49.45-6,73.94c5.33,28.49,28.92,54.23,60.74,66.25,28.35,10.71,63.83,10,89-5.11,12.27-7.38,21.55-17.63,29.62-28.23a227.74,227.74,0,0,0,29.45-51c3.51-8.49,6.81-17.62,15-23.52,5-3.63,11.48-5.66,17.89-7.24,19.32-4.76,39.67-6.06,59.17-10.3s39.07-12.15,49.67-26.28c15-20,8-45.62,8.07-69.14.12-53.66,39.11-101.69,53.5-154,4.7-17.09,6.45-36-4.05-51.25-7.13-10.35-19.16-17.82-31.8-23.59-27.81-12.69-59.42-18.34-90.51-23.84-43.21-7.64-95.68-8.63-129.17-33.35C297.76,115.65,253.79,98.74,210,98.74Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.93,404.47c-2.14,3.16-3.9,7.75-1.1,13.1,5.5,10.5,19.1,8.34,25.71,18.39a18.38,18.38,0,0,1,2.85,9.29c.25,5.69-1.51,10.17-2.42,15.18a25.66,25.66,0,0,0,2.62,17.34,30.62,30.62,0,0,0,14,12.49c5.12,2.26,10,2.84,14.9,3.94a91.71,91.71,0,0,1,17.67,6,33.36,33.36,0,0,1,7.54,4.4,54.91,54.91,0,0,1,7.63,8.22l21.27,26.26a75.18,75.18,0,0,0,9,9.84,54.21,54.21,0,0,0,11.72,7.21c8.49,4.23,17.37,8.56,24.74,8.07s12.49-7.6,9-17.54c-3.3-9.46-12.6-17.43-16.82-26.87-6.65-14.88,2.06-26-3.51-40.9-5.34-14.32-20.31-23.92-29.87-37C192,432.59,188.18,421.77,182,412c-9-14-22.4-24.71-35-30.13A67.93,67.93,0,0,0,111.84,377c-4.56.5-9.05,1.35-12.29,4.08-3.44,2.9-3,8.32-5.24,12.17C91.74,397.68,86.84,400.19,83.93,404.47Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.28,384.33S203.76,483.88,246.7,561.39",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.24,418.18s42.55-8.27,72,24.9",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.48,480.69s47-32.87,63.26-13.75",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,381.63s-4.95,25.16,12.86,66.26",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.68,479.28s-4.16,16.5-37.6,4.37",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.73,537s20.41-23.59,11.13-35.17",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.92,289c-5,5.91-9.68,14.09-6,22.16C65,327,91.21,319.25,100.56,334c2.8,4.41,3.18,9.8,2.53,14.61-1.26,9.41-5.92,17.4-9.14,26s-4.89,19-.35,28.08c4.37,8.79,13.58,14.34,22.5,16.55s17.86,1.71,26.77,2a148.2,148.2,0,0,1,31.35,4.62A43.31,43.31,0,0,1,187,431c4.55,2.91,8.23,7.18,11.83,11.38l32,37.29c4.25,5,8.59,10,13.86,13.67,6.08,4.23,13,6.38,19.81,8.45,14.65,4.48,30,9,44,5.93s25.75-16.45,22.25-31.94c-3.33-14.75-18.35-25.21-23.41-39.66-8-22.77,11.75-43.89,5.82-67.06-5.68-22.22-30.86-33.68-44.86-52.49-10-13.48-13.94-30.34-22.68-44.68C233,251.19,211,237.48,189.1,232.27s-43.93-2.78-64.47,2.43c-8.7,2.21-17.4,5-24.3,10.52C93,251.09,92.16,260,86.82,267.08,80.63,275.31,70.66,281,63.92,289Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.07,251.4S264.74,384.9,321.83,501",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.46,312S140.83,285.35,186,331.66",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.26,407s98.11-69,122.91-42.09",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.85,231.88s-16.91,43.39,4,106.46",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M312.9,369.69s-12.81,28.73-71.9,18.68",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.69,476.1s45.47-45.48,31.57-62",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 617.97,
    cy: 647.16,
    rx: 465,
    ry: 124.52,
    fill: "#009ddd",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.74,55.53s-35.83,35.83-15.6,89-34.68,141.59-34.68,141.59.59-.09,1.68-.28c73.59-13,110.16-97.16,69.24-159.69C1042.17,102.91,1029.68,75.65,1036.74,55.53Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1036.74,55.53s-20.23,43.92,0,79.75,3.47,136.39-50.28,150.84",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.56,200.46s-40.89-6.51-44.61,30.13-78.62,41.72-78.62,41.72l1.4.93c61.84,40.59,121,25.86,112-28C1087.46,225.16,1087.73,205,1100.56,200.46Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.56,200.46s-40.89-6.51-44.61,30.13-78.62,41.72-78.62,41.72l1.4.93c61.84,40.59,121,25.86,112-28C1087.46,225.16,1087.73,205,1100.56,200.46Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f5f5f5",
    opacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.56,200.46s-31.74,7-29.13,35.82-47.13,63.45-94.1,36",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303.29,334.92s-13.26-45,2.49-78.14a71.09,71.09,0,0,0,5.75-44.6,119.57,119.57,0,0,0-6.31-20.93",
    transform: "translate(-56.59 -55.12)",
    fill: "none",
    stroke: "#535461",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M315,170.3c0,5.52-10,21.51-10,21.51s-10-16-10-21.51a10,10,0,1,1,20,0Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M331.52,200.86c-3,4.63-20.08,12.63-20.08,12.63s.31-18.86,3.31-23.49a10,10,0,1,1,16.77,10.86Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M330.8,253.08c-4.93,2.48-23.71.77-23.71.77s9.79-16.12,14.71-18.6a10,10,0,1,1,9,17.84Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M321.36,292.46c-4.44,3.28-23.24,4.76-23.24,4.76s6.92-17.54,11.36-20.82a10,10,0,1,1,11.88,16.06Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M290.47,214.56c4,3.84,22.39,7.83,22.39,7.83s-4.51-18.31-8.47-22.15a10,10,0,1,0-13.92,14.33Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M280,260.76c4.93,2.48,23.71.77,23.71.77s-9.79-16.12-14.71-18.6a10,10,0,0,0-9,17.84Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M276,307.06c4.44,3.28,23.24,4.76,23.24,4.76s-6.92-17.54-11.36-20.82A10,10,0,0,0,276,307.06Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M1129,596.62h-85.09a28.36,28.36,0,0,0,3-12.67V196.47A28.49,28.49,0,0,0,1018.42,168H359.75a28.49,28.49,0,0,0-28.49,28.49V583.95a28.36,28.36,0,0,0,3,12.67h-88.1a7.53,7.53,0,0,0-7.53,7.53v6.07a42.14,42.14,0,0,0,42.14,42.14h813.68a42.14,42.14,0,0,0,42.14-42.14v-6.07A7.53,7.53,0,0,0,1129,596.62ZM604.71,620.72l-7.3-8.29H778.52l-8.08,8.29Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#22371c7b-1b7b-4aab-a60b-8a215b8ce92d)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 282.74,
    y: 118.35,
    width: 699.44,
    height: 434.39,
    rx: 23.26,
    ry: 23.26,
    fill: "#535461"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 297.47,
    y: 181.67,
    width: 668.52,
    height: 354.87,
    fill: "#f1f1f4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 631.73,
    cy: 150.74,
    r: 5.89,
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M791.54,592.39l-23,23.56h-162l-20.76-23.56H256.13a7.36,7.36,0,0,0-7.36,7.36v5.94A41.18,41.18,0,0,0,290,646.87H1085.2a41.18,41.18,0,0,0,41.18-41.18v-5.94a7.36,7.36,0,0,0-7.36-7.36Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#535461"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 338.3,
    y: 208.71,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 220.63,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 220.63,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 233.87,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 247.11,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 260.36,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 273.6,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 286.85,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 300.09,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 313.33,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 326.58,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 539.61,
    y: 208.71,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 220.63,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 220.63,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 233.87,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 247.11,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 260.36,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 273.6,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 286.85,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 300.09,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 313.33,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 326.58,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 740.91,
    y: 208.71,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 220.63,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 834.28,
    y: 220.63,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 834.28,
    y: 233.87,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 834.28,
    y: 247.11,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 260.36,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 273.6,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 286.85,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 300.09,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 313.33,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 758.79,
    y: 326.58,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 338.3,
    y: 363.66,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 375.58,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 375.58,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 388.83,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 431.67,
    y: 402.07,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 415.31,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 428.56,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 441.8,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 455.05,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 468.29,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 356.18,
    y: 481.53,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 539.61,
    y: 363.66,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 375.58,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 375.58,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 388.83,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 632.98,
    y: 402.07,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 415.31,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 428.56,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 441.8,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 455.05,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 468.29,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 557.48,
    y: 481.53,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 740.91,
    y: 363.66,
    width: 182.77,
    height: 137.74,
    opacity: 0.1
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M498.66,310.18h-282A25.83,25.83,0,0,0,190.78,336V726.74a25.83,25.83,0,0,0,25.87,25.8h282a25.83,25.83,0,0,0,25.87-25.8V336A25.83,25.83,0,0,0,498.66,310.18Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#d4a1e37c-1d20-4442-be38-826149171c3f)"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 138.17,
    y: 260.36,
    width: 325.8,
    height: 433.08,
    rx: 20,
    ry: 20,
    fill: "#535461"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 154.72,
    y: 301.33,
    width: 292.69,
    height: 351.15,
    fill: "#f1f1f4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.74,
    cy: 280.23,
    r: 3.97,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 299.74,
    cy: 672.25,
    r: 11.92,
    fill: "#fff"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 167.37,
    y: 337.21,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 342.66,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 342.66,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 348.71,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 354.76,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 360.81,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 366.86,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 372.91,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 378.96,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 385.01,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 391.06,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 259.33,
    y: 337.21,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 342.66,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 342.66,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 348.71,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 354.76,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 360.81,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 366.86,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 372.91,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 378.96,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 385.01,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 391.06,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 351.28,
    y: 337.21,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 342.66,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 342.66,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 348.71,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 354.76,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 360.81,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 366.86,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 372.91,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 378.96,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 385.01,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 391.06,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 167.37,
    y: 407.99,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 413.44,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 413.44,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 419.49,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 425.54,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 431.59,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 437.64,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 443.69,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 449.74,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 455.79,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 461.84,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 259.33,
    y: 407.99,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 413.44,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 413.44,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 419.49,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 425.54,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 431.59,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 437.64,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 443.69,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 449.74,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 455.79,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 461.84,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 351.28,
    y: 407.99,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 413.44,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 413.44,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 419.49,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 425.54,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 431.59,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 437.64,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 443.69,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 449.74,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 455.79,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 461.84,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 167.37,
    y: 481.57,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 487.02,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 487.02,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 493.07,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 499.12,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 505.17,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 511.22,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 517.27,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 523.32,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 529.37,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 535.42,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 259.33,
    y: 481.57,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 487.02,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 487.02,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 493.07,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 499.12,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 505.17,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 511.22,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 517.27,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 523.32,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 529.37,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 535.42,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 351.28,
    y: 481.57,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 487.02,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 487.02,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 493.07,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 393.93,
    y: 499.12,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 505.17,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 511.22,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 517.27,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 523.32,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 529.37,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 359.45,
    y: 535.42,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 167.37,
    y: 552.35,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 557.8,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 557.8,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 563.85,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 210.02,
    y: 569.9,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 575.95,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 582,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 588.05,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 594.1,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 600.15,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 175.54,
    y: 606.2,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 259.33,
    y: 552.35,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 557.8,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 557.8,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 563.85,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 301.98,
    y: 569.9,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 575.95,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 582,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 588.05,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 594.1,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 600.15,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 267.49,
    y: 606.2,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 351.28,
    y: 552.35,
    width: 83.48,
    height: 62.92,
    opacity: 0.1
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M283.71,442.62H138.91a14.32,14.32,0,0,0-14.35,14.29V774a14.32,14.32,0,0,0,14.35,14.29h144.8A14.32,14.32,0,0,0,298.06,774V456.92A14.32,14.32,0,0,0,283.71,442.62Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#52583eb6-2034-4198-bc7c-1e2be9031359)"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 69.3,
    y: 390.16,
    width: 170.85,
    height: 341.7,
    rx: 11,
    ry: 11,
    fill: "#535461"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 81.88,
    y: 421.94,
    width: 145.68,
    height: 278.12,
    fill: "#f1f1f4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.5,
    cy: 406.05,
    r: 1.32,
    fill: "#fff"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 144.13,
    y: 404.72,
    width: 29.14,
    height: 2.65,
    rx: 1,
    ry: 1,
    fill: "#fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 154.06,
    cy: 713.31,
    r: 9.27,
    fill: "#fff"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 105.05,
    y: 438.59,
    width: 99.34,
    height: 74.87,
    opacity: 0.1
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 105.05,
    y: 522.82,
    width: 99.34,
    height: 74.87,
    fill: "#fff"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 529.3,
    width: 33.11,
    height: 18.72,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 529.3,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 536.5,
    width: 27.36,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 543.69,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 550.89,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 558.09,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 565.29,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 572.49,
    width: 73.43,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 579.69,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 586.89,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 105.05,
    y: 607.22,
    width: 99.34,
    height: 74.87,
    fill: "#fff"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 613.7,
    width: 33.11,
    height: 18.72,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 613.7,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 620.9,
    width: 27.36,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 155.8,
    y: 628.1,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 635.3,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 642.5,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 649.7,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 656.9,
    width: 73.43,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 664.09,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 114.77,
    y: 671.29,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M600.25,697.71c-6.72-8.15-14.86-17.52-13.72-28.37.92-8.79-1.29-16.91-.85-25.72.62-12.52-1.91-22.33-10.93-30.36-5.27-4.69-14.08-8.38-16.7-7.44-5.2,1.86-10.87,1.15-16.22,2.4-4.06,1-6.77,2.41-8.44,4.24-3.37,3-3.43,7.26-1.89,11.81a19.94,19.94,0,0,0,9.88,28c-3.75,1.56-7,5.17-8.25,12.49a85.41,85.41,0,0,1-4,14.76,24,24,0,0,1-2.44,1c.18.07.37.12.56.19-.39.15-.79.3-1.18.44a12.88,12.88,0,0,0,2.22.64,84.83,84.83,0,0,1-10.9,19.87s-11.32,2.5-15.72-1.87c0,0,.72.84,1.69,2.1-4.31-1.79-11.37-4.7-17.41-7.1-4.38-1.74-5.51,0-5.45,2.42a8.09,8.09,0,0,0-3.06,1,29.55,29.55,0,0,0-4.06-2.18c-2.52-.62-10.69-5-18.87,10-4.76,8.73-17,24.65-26.35,36.44-18.25,8.39-42,19-50.82,21.69H371.7c-.74-1.21-1.26-2-1.26-2l-.44.29-.19-.29s-11.11,7.69-22.39,7.75a21.22,21.22,0,0,1-4.76-.62c-5.19-1.31-8.84-1.89-11.45-1.84-3.09-.05-4.84.68-5.93,2.06h0a5.43,5.43,0,0,0-.39.57h0a6.71,6.71,0,0,0-.33.63v0c-.1.22-.19.45-.28.69a1.41,1.41,0,0,0,.35,1.18,6.32,6.32,0,0,0,.49.62l.31.34a50,50,0,0,0,7.23,5.59c.93.63,1.91,1.27,2.94,1.93l1.95,1.24,1.74,1.09.7.43.78.48,1.39.85.83.5,1.56.93,1.26.75c3.3,2,6.6,3.84,9.56,5.51l2.08,1.17.2.11,1.33.74,2.31,1.28,1.59.87.74.41.8.43.16.09,1.38.75a2,2,0,0,0,1.61-.44c.4-1.7,1.38-5.34,2.42-5.62s5.58-8.24,6.87-13.54h12.27A54.11,54.11,0,0,0,396.3,778c-3.17,2.26-6.31,3.68-8.75,3.07-5.16-1.28-10.05,1.86-10.54,5l-.06.19c0,.06,0,.13,0,.19s0,.15,0,.23,0,.13,0,.19,0,.15,0,.23,0,.13,0,.19,0,.16,0,.23,0,.12,0,.18,0,.17.06.25,0,.11,0,.16a3,3,0,0,0,.13.32l0,.08a3.27,3.27,0,0,0,.23.38l.1.13.2.25.14.14.23.22.17.14.27.2.2.13.33.19.22.12.41.19.21.09c.22.09.45.18.7.26s.86.26,1.39.39l.53.13.77.18.41.09,1.68.34.82.15.67.12,1.54.27,3,.49,2.65.4,3.45.49.76.1,1.24.17,1.78.24,1.22.16h0l3.15.4,1,.12,2,.24c2.61.31,5.14.61,7.46.87l2.69.3,1.36.15.58.06,1.63.18.91.1,1.11.12,1.57.16.17,0,1,.1h0a.91.91,0,0,0,1-.89v0h0s0-.07,0-.1a.89.89,0,0,0,.15-.48,20.65,20.65,0,0,1,.56-4.44c.07-.25.15-.51.23-.76l.1-.29c.11-.31.22-.62.35-.94a6.75,6.75,0,0,0,.23-.69l.06-.22c0-.12.06-.25.09-.38,1.27-4.32-.26-12.37-.7-15.53a16.86,16.86,0,0,0-.69-3,1.22,1.22,0,0,0,.24,0,7.16,7.16,0,0,0,1.82-1c9.27-3.31,17.1-7.09,19.57-10.88a16.94,16.94,0,0,1,12,1.25c4.8,2.39,41.13,14.24,58.05,19.72,3,2.62,5.42,4.15,6.73,4,0,0,21.53,3.48,30.19-3.32.77.53,1.25.82,1.25.82s12.58-6.25,14.47-14.37c.61-2.63,1.16-6.52,1.72-10.82a15.73,15.73,0,0,0,4.57-11.06c.39-13.65,5.68-29.24,9.6-43.13,4.76.37,6.6-.52,11-2.68l-.19-.25Zm-72.12,20.44-2.4-.81a20,20,0,0,0,2.09-3.48Zm-13.54,5.74,14.58,8.75.13,1.78a12.77,12.77,0,0,0,.12,4.07C523,732.78,515.48,725.85,514.6,723.89Zm-5.95-12.74c-1.59-.66-2.91-1.25-3.81-1.74l3.38.21A7.55,7.55,0,0,1,508.65,711.15Zm-39,14.25s2.52-5.62,8.18,3.75c.88,1.46,2.5,3.77,4.64,6.65L466,733.59A24,24,0,0,0,469.62,725.4Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#a16bfa34-d1a3-4472-9999-21ee7545ab3e)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M505.85,702.81s-11.54-4.86-20.64-8.5-3.64,8.5-3.64,8.5,15.18,4.25,15.18,4.86,12.75,1.21,12.75,1.21Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f7c4a7"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M505.85,702.81s-11.54-4.86-20.64-8.5-3.64,8.5-3.64,8.5,15.18,4.25,15.18,4.86,12.75,1.21,12.75,1.21Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.05
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M555,654.85s-20.64-10.93-24.29,10.32A86.75,86.75,0,0,1,515.56,701s-10.93,2.43-15.18-1.82c0,0,10.32,12.14,5.46,13.36,0,0,10.93,7.89,15.79,5.46s8.5-18.82,10.32-23.07S540.45,653.63,555,654.85Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M555,654.85s-20.64-10.93-24.29,10.32A86.75,86.75,0,0,1,515.56,701s-10.93,2.43-15.18-1.82c0,0,10.32,12.14,5.46,13.36,0,0,10.93,7.89,15.79,5.46s8.5-18.82,10.32-23.07S540.45,653.63,555,654.85Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M543.49,647.56s12.75,14.57,13.36,26.71,14.57-12.75,15.79-13.36S560.49,639.67,559.27,633,543.49,647.56,543.49,647.56Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f7c4a7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "495.7 598.67 487.66 605.95 491.45 621.28 501.77 611.57 500.56 601.86 495.7 598.67",
    fill: "#f7c4a7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "327.83 706.59 313.87 706.59 319.33 719.94 332.69 716.3 327.83 706.59",
    fill: "#f7c4a7"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M373.68,759.78s-14.44,10.07-26.81,6.93-15.71-2-17.15,2.09c-1.33,3.72,34.51,23.41,40.22,26.52a.65.65,0,0,0,1-.43c.39-1.65,1.33-5.19,2.33-5.46,1.31-.35,7.3-11.52,7-15.93S373.68,759.78,373.68,759.78Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M373.08,759.78s-14.44,10.07-26.81,6.93-15.71-2-17.15,2.09c-1.33,3.72,34.51,23.41,40.22,26.52a.65.65,0,0,0,1-.43c.39-1.65,1.33-5.19,2.33-5.46,1.31-.35,7.3-11.52,7-15.93S373.08,759.78,373.08,759.78Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f3b5b7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M492.49,735.6l-40.68-5.46s-66.18,31.57-74.07,32.18l1.82,14H391.7c4.86,0,52.21-10.32,58.89-20.64a16.26,16.26,0,0,1,11.54,1.21c6.07,3,64.36,21.86,64.36,21.86Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M492.49,735.6l-40.68-5.46s-66.18,31.57-74.07,32.18l1.82,14H391.7c4.86,0,52.21-10.32,58.89-20.64a16.26,16.26,0,0,1,11.54,1.21c6.07,3,64.36,21.86,64.36,21.86Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.65 699.3 356.97 707.8 363.65 711.44 373.37 704.16 363.65 699.3",
    fill: "#f7c4a7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M536.2,744.7S514.36,726,512.83,722.6s-37.34-26.46-39.77-27.07-10.32-4.86-18.21,9.71-37,49.78-37,49.78,9.11,12.75,12.14,12.14,37-29.14,39.46-43.11c0,0,2.43-5.46,7.89,3.64s40.68,52.82,47.36,52.21c0,0,26.11,4.25,31.57-6.07S536.2,744.7,536.2,744.7Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 382.57,
    y: 591.56,
    width: 90.91,
    height: 68.51,
    fill: "url(#acc52bd5-c2c3-4362-a9d1-2a5a10558a32)"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 386.28,
    y: 594.35,
    width: 83.48,
    height: 62.92,
    fill: "#fff"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 599.8,
    width: 27.83,
    height: 15.73,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 428.93,
    y: 599.8,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 428.93,
    y: 605.85,
    width: 22.99,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 428.93,
    y: 611.9,
    width: 32.67,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 617.95,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 624,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 630.05,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 636.1,
    width: 61.71,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 642.15,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 394.45,
    y: 648.2,
    width: 67.15,
    height: 3.63,
    fill: "#e6e8ec"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M548.65,655.76s-7.59,3.34-8.2,17.3-14,37.64-14,37.64l1.21,27.93s14.57,14.57,15.79,23.68S555,777.49,555,777.49s12.14-6.07,14-14,3-27.32,6.07-34.61,1.21-52.82,1.21-52.82l-9.11-15.79-4.86-5.46-12.75,14.57S542.58,660,548.65,655.76Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f3b5b7"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M530.74,729.52s-1.82-21.86,3.64-26.71l10.93-31s3.95-14.87,3.34-16.09-14.27,11.84-14.27,11.84l-9.11,32.18,2.43,34Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M530.13,729.52s-1.82-21.86,3.64-26.71l10.93-31s4.25-15.18,3.64-16.39-14.57,12.14-14.57,12.14l-9.11,32.18,2.43,34Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M534.38,719.81S504,710.1,502.2,707.67s-21.25-18.21-27.93-7.29,24.89,14,24.89,14l32.18,19.43Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f7c4a7"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M421.55,762.86l-9-1.62s-14.72,18.85-22.38,16.94-14.72,6.34-6.62,9c7.32,2.39,38.91,5.74,44.95,6.36a.88.88,0,0,0,1-.86,19.33,19.33,0,0,1,1.34-6.84c1.62-4,0-12.52-.45-15.76a15.68,15.68,0,0,0-1.77-5.45Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M421.41,763.45l-9-1.62S397.71,780.69,390,778.77s-14.72,6.34-6.62,9c7.32,2.39,38.91,5.74,44.95,6.36a.88.88,0,0,0,1-.86,19.33,19.33,0,0,1,1.34-6.84c1.62-4,0-12.52-.45-15.76a15.68,15.68,0,0,0-1.77-5.45Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f3b5b7"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 491.45,
    cy: 580,
    r: 19.43,
    opacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 489.63,
    cy: 580,
    r: 19.43,
    fill: "#f7c4a7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M565.34,654.24s23.07,7.89,23.07,24.29-12.75,42.5-13.36,63.75-34,18.21-34,18.21-4.86-71.64,0-77.11S567.77,656.67,565.34,654.24Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M561.09,688.24s-8.5,37.64-28.54,31c0,0-10.32,15.18-3,21.86,0,0,17.61,4.25,29.14-7.29S578.7,718,580.52,704s3-33.39-3-31.57S561.09,688.24,561.09,688.24Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M561.7,687.63s-8.5,37.64-28.54,31c0,0-10.32,15.18-3,21.86,0,0,17.61,4.25,29.14-7.29s20-15.79,21.86-29.75,3-33.39-3-31.57S561.7,687.63,561.7,687.63Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#575988"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M431.19,784.48c0,.06,0,.12-.06.17a17.78,17.78,0,0,0-1,3.21c.14-.48.31-1,.51-1.45A8.81,8.81,0,0,0,431.19,784.48Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#dddbe2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M383.87,786c-2.5-.82-3.55-2.17-3.59-3.59-1,2-.38,4.2,3.15,5.36,7.32,2.39,38.92,5.74,44.95,6.36a.88.88,0,0,0,1-.87v0a.89.89,0,0,0-.79-.9C421.94,791.64,391.09,788.35,383.87,786Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#dddbe2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M329.95,767.73a7.48,7.48,0,0,1,.59-1.29,5.92,5.92,0,0,0-1.43,2.36c-1.33,3.72,34.51,23.4,40.22,26.52a.66.66,0,0,0,1-.43v0a.66.66,0,0,0-.32-.73C363.67,790.7,328.63,771.41,329.95,767.73Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#dddbe2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M373.46,788.36c-.32.09-.64.51-.93,1.11l.1,0c.26-.07.72-.59,1.28-1.4A1.18,1.18,0,0,1,373.46,788.36Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#dddbe2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M543.52,652.22c-1.71,3.77-2.07,8-3.33,12a26.37,26.37,0,0,1-16.25,16.86c6.31,2.52,13.75-.56,18.63-5.66s7.73-11.89,10.47-18.49c7.08,4.76,6.22,15.7,8.59,24.22a26.86,26.86,0,0,0,14.3,17.09,25.6,25.6,0,0,0,21.9-.44c-6.49-7.92-15.73-18.78-14.63-29.32.89-8.54-5.24-15.06-4.81-23.62.6-12.16-4-18.31-12.75-26.11-5.09-4.56,2.92-11-3.64-9.11-2.58.74-5.3-2-7.83-1.11-5,1.8-10.49,1.12-15.65,2.33C511.69,617.14,546,646.71,543.52,652.22Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M544.13,651.61c-1.71,3.77-2.07,8-3.33,12a26.37,26.37,0,0,1-16.25,16.86c6.31,2.52,13.75-.56,18.63-5.66s7.73-11.89,10.47-18.49c7.08,4.76,6.22,15.7,8.59,24.22a26.86,26.86,0,0,0,14.3,17.09,25.6,25.6,0,0,0,21.9-.44c-6.49-7.92-15.12-17-14-27.5.89-8.54-.44-17.31,0-25.87.6-12.16-5.35-23.87-14.06-31.67-5.09-4.56-13-5.14-15.57-4.23-5,1.8-10.49,1.12-15.65,2.33C512.3,616.54,546.63,646.1,544.13,651.61Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#b96b6b"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M220.42,836.49c35-10.77,55.66-9.88,55.66-9.88l-2.87-16.27a12.3,12.3,0,0,0,2.42-2.13s-3.59-19.75,0-24.69S289.1,733.7,289.1,733.7V718.43c18-6.28,39.05-42.64,39.05-42.64L354.64,744s26.48,52.52,30.07,54.31c2.87,1.43,4.3,13.18,4.77,17.85l-.22.07c.11,1.13.16,1.83.16,1.83l.21-.14v.14a10.29,10.29,0,0,1,1.4-.82c-5.17,5.94-12.91,14.48-19.35,20.12-3.55,3.11,2.82,5.51,5.8,5.46a14.62,14.62,0,0,1,5,.71c15.09,5.21,39.9-13.81,39.9-13.81l-6.21-17.32c1.62-.13,2.62-.19,2.62-.19s-20.2-70.92-29.63-77.66a43,43,0,0,1-8-7.58,28,28,0,0,1-6.33-19.44l3.31-58.19c5.32-.78,8.75-1.43,8.75-1.43s1.24-15.9,1.2-28.1c0-6.35-.26-11.92-1.2-14.1-1.11-2.58-1.46-7.74-1.48-12.92,0-7,.58-13.56.58-13.56s7.18-9.43,17.06-31c4.35-9.49,5.48-17,5.38-22.38a30.53,30.53,0,0,0-.72-7.46,9.35,9.35,0,0,0-4.23-5.87c-5.68-3.48-18.61-12.07-22.42-20.39-4.84-10.56-11.83-12.06-12.11-12.12l-.43-1.86a17.45,17.45,0,0,0,5.62-8.52c1.46-4.5,1.76-9.3,3-13.87.6-2.2,1.43-4.33,2-6.53a25.79,25.79,0,0,0,.81-6.78,21,21,0,0,0-2-9.65c-2.32-4.77-6.94-8.52-12.2-9.14-2.9-.34-6.11.16-8.49-1.53-1.64-1.17-2.5-3.16-4-4.55-2.85-2.7-7.41-2.56-11.12-1.3a23.69,23.69,0,0,0-12.16,9.47c-1.73,2.66-2.94,5.71-5.16,8-1.87,1.91-4.32,3.13-6.38,4.83a13,13,0,0,0-5,10s0,.1,0,.15c0,.25,0,.5,0,.75.1,3.86,2.79,7.7,6.57,8.48a9.7,9.7,0,0,0,3,.08A24.24,24.24,0,0,0,341,488c-.06.32-.13.64-.2,1l.21,0a34.65,34.65,0,0,1-1.62,4.56l-.29,0,.73-1.3-10.3-.71a17.26,17.26,0,0,0-8.72,1.63c-3.55,1.72-7.43,5-7.91,11.2C312,516,290,533.5,290,533.5c-7.63,12.12-57.46,14.36-57.46,14.36s.22.28.32.43l-1-.19-3.77-.69s-11.67-34.56-22.89-28.28,19.3,40.4,19.3,40.4l8.82.59.89.06a53.85,53.85,0,0,1-1.39,6.63h0c-.12.44-.21.72-.23.79v0s23.2-2.68,42.91-2.25h1.78l1.26-.06c1,10.83,16.44,32.84,16.44,32.84l9.53,2,.72.15a79.68,79.68,0,0,1-11.6,17.59l-3.14,17.51.25-.06-.25,1.41a3.39,3.39,0,0,0,1.45-.76c-6.15,16.32-16.35,41.72-23.44,50.58-10.77,13.47-9.43,35-9.43,35s-10.77,56.56-10.32,66.88a26.6,26.6,0,0,1-3.89,14.13,46.72,46.72,0,0,0-5.54,7.87c-8.08,13.92-21.1,13-21.1,13C207,830.65,220.42,836.49,220.42,836.49ZM289.75,562.7h0l1.16-.46.27-.11,1.11-.48.19-.09,1-.46.22-.1,1.06-.53.25-.13,1-.53.08,0,1-.58.24-.14,1-.58.16-.1.87-.53.2-.12.93-.59.21-.14.86-.57.08-.05.88-.61.2-.14.84-.6.13-.09.74-.54.16-.12.77-.59.16-.12.7-.55.06,0,.71-.57.15-.12.67-.55.06-.05.6-.51.1-.09.59-.51.09-.08.54-.49h0l.52-.47.07-.07,1-1,1.46-.12c1.24,1.61,1.73,4.46,1.78,7.73-.14,8.39-2.68,18.75-2.68,18.75a58.47,58.47,0,0,1-2.66,15.14,8.92,8.92,0,0,1-3.17-.77s-.06.32-.15.86l-.86-.22-4.37-1.09S297.1,570.34,289.75,562.7Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#c79e9d42-5070-416c-b31a-75c30b54975b)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M411.48,801.79,419.81,825S397,842.5,382.18,838.88a41.42,41.42,0,0,0-6.8-1.1c-3.07-.23-8.35-2.46-5.09-5.31,10.52-9.2,24.54-26.29,24.54-26.29Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#4f4d59"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M273,799.6l3.94,22.35s-20.16-.88-54.34,9.64c0,0-13.15-5.7-2.19-12.71,0,0,12.71.88,20.6-12.71s12.71-11.83,12.71-11.83Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#4f4d59"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3,637.45l-3.86,68a28.13,28.13,0,0,0,6.71,19.89,41.23,41.23,0,0,0,7.24,6.75c9.2,6.57,28.92,75.81,28.92,75.81s-22.35,1.31-28.48,5.7c0,0-1.31-17.53-4.82-19.28s-29.36-53-29.36-53L327.78,674.7s-20.6,35.5-38.13,41.63v14.9s-9.64,43.82-13.15,48.64,0,24.1,0,24.1-10.08,12.71-33.3-.88c0,0,7.45-8.33,7-18.41S260.3,719.4,260.3,719.4s-1.31-21,9.2-34.18,28-63.54,28-63.54l12.06-25.95Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#787c9c"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M412.14,807.92s-19.72-69.24-28.92-75.81a41.75,41.75,0,0,1-7.61-7.19,27.81,27.81,0,0,1-6.33-19.44l3.86-68-64.63-39.84.88-1.89,67.69,41.72-3.86,68a27.81,27.81,0,0,0,6.33,19.44,41.75,41.75,0,0,0,7.61,7.19c9.2,6.57,28.92,75.81,28.92,75.81s-22.35,1.31-28.48,5.7c0,0-.05-.68-.16-1.79C396.06,808.87,412.14,807.92,412.14,807.92Z",
    transform: "translate(-56.59 -55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.35,804s-3.51-19.28,0-24.1,13.15-48.64,13.15-48.64v-14.9c17.53-6.14,38.13-41.63,38.13-41.63l1.53,3.95c-5.94,9.42-21.79,32.81-35.71,37.68v14.9s-9.64,43.82-13.15,48.64,0,24.1,0,24.1-4.89,6.15-15.69,5.32C268.66,808.63,272.35,804,272.35,804Z",
    transform: "translate(-56.59 -55.12)"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M226.55,561.2l8.61.57,4.54.3v-11l-6-1.08-3.69-.67s-11.39-33.74-22.35-27.61S226.55,561.2,226.55,561.2Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#714b4f"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M364.59,470.93s5.7,21.91,7.45,35.5-40.75,2.63-40.75,2.63,16.21-19.72,7-30.24Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#714b4f"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M318.58,562.08l-.88,8.33,13.58-.88,13.58-11.83,13.58-38.13L367.22,506l6.57-8.33-2.63-10.08s-1.2,1-3.23,2.6c-6.67,5.11-22.33,15.72-33.77,12.79a13.64,13.64,0,0,1-1.56-.49l-17.09,29.36Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#e6e6f0"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M367.66,485s7,1.31,11.83,11.83c3.71,8.09,16.22,16.43,21.81,19.86a9.35,9.35,0,0,1,4.24,5.91c1.13,5,1.56,14.3-4.58,27.7-9.64,21-16.65,30.24-16.65,30.24s-1.75,21,.88,27.17,0,39.88,0,39.88-46,8.76-61.35,0S310.69,605,310.69,605,296.23,635.7,291,636.58L294,619.49s17.09-18.41,18-42.07c0,0,5.26-21.47.88-27.17,0,0-74.06,6.14-78.44.88,0,0,48.64-2.19,56.09-14,0,0,21.47-17.09,22.35-28.48a12.6,12.6,0,0,1,6.57-10.32,17.16,17.16,0,0,1,9.82-2.19l9.9.68S322.09,527,323,531s-.88,35.93-.88,35.93,19.72-42.51,28.48-47.33S369.41,495,369.41,495l-1.75-10",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M318.58,562.08l-.88,8.33,13.58-.88,13.58-11.83,13.58-38.13L367.22,506l6.57-8.33-2.63-10.08s-1.2,1-3.23,2.6l.6,3.46s-10.08,19.79-18.84,24.61-28.48,47.33-28.48,47.33,1.75-32,.88-35.93c-.6-2.68,7.08-17.45,12.07-26.68a13.64,13.64,0,0,1-1.56-.49l-17.09,29.36Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M235.16,561.78l4.54.3v-11l-6-1.08C235.81,552.8,235.74,557.66,235.16,561.78Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M367.66,483.64s7,1.31,11.83,11.83c3.71,8.09,16.22,16.43,21.81,19.86a9.35,9.35,0,0,1,4.24,5.91c1.13,5,1.56,14.3-4.58,27.7-9.64,21-16.65,30.24-16.65,30.24s-1.75,21,.88,27.17,0,39.88,0,39.88-46,8.76-61.35,0-13.15-42.51-13.15-42.51S296.23,634.39,291,635.26L294,618.17s17.09-18.41,18-42.07c0,0,5.26-21.47.88-27.17,0,0-17.09,18.41-36.37,18s-42.07,2.19-42.07,2.19,4.38-14,0-19.28c0,0,48.64-2.19,56.09-14,0,0,21.47-17.09,22.35-28.48A12.6,12.6,0,0,1,319.46,497a17.16,17.16,0,0,1,9.82-2.19l9.9.68S322.09,525.71,323,529.65s-.88,35.93-.88,35.93,19.72-42.51,28.48-47.33,18.84-24.61,18.84-24.61l-1.75-10",
    transform: "translate(-56.59 -55.12)",
    fill: "#67647e"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3,529.65s-10.52,35.5-16.65,39.88S317.27,596.26,306.31,591c0,0-2.63,13.15,1.31,16.21,0,0,40.86-1.6,41.19-1.75,0,0,26.73-3.51,31.11-16.65s9.64-35.5,9.64-35.5Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 264.62,
    cy: 512.44,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.24,
    cy: 527.78,
    rx: 1.53,
    ry: 2.19,
    fill: "#ba7855"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.12,645.78s2.63-33.74,0-39.88-.88-27.17-.88-27.17,7-9.2,16.65-30.24c6.14-13.4,5.7-22.7,4.58-27.7a9.35,9.35,0,0,0-4.25-5.91c-5.59-3.43-18.1-11.77-21.8-19.86-2.72-5.93-6.13-8.94-8.6-10.43l-.17-1s7,1.31,11.83,11.83c3.71,8.09,16.22,16.43,21.8,19.86a9.35,9.35,0,0,1,4.25,5.91c1.13,5,1.56,14.3-4.58,27.7-9.64,21-16.65,30.24-16.65,30.24s-1.75,21,.88,27.17,0,39.88,0,39.88-32.87,6.26-52.31,2.91C352.51,651.42,382.12,645.78,382.12,645.78Z",
    transform: "translate(-56.59 -55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,529.65c.6,2.7,0,18.58-.49,28.3-2.12,4.33-3.45,7.19-3.45,7.19s1.75-32,.88-35.93c-.83-3.75,14.56-31.25,16.09-34l3.19.22S322.09,525.71,323,529.65Z",
    transform: "translate(-56.59 -55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.44,566.46c19.28.44,36.37-18,36.37-18a7,7,0,0,1,1.11,2.38c-5,4.71-19,16.38-34.41,16-19.28-.44-42.07,2.19-42.07,2.19s.09-.29.23-.79A348.85,348.85,0,0,1,273.44,566.46Z",
    transform: "translate(-56.59 -55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.62,603.27s-.18,2.74-.08,6.85c-4.56,9-12.86,24.52-16.57,25.14l.65-3.6C298,623.65,307.62,603.27,307.62,603.27Z",
    transform: "translate(-56.59 -55.12)"
  }))), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 151.35,
    y: 437.56,
    width: 104.75,
    height: 78.94,
    fill: "url(#d299ef7c-b001-4b07-9539-ad7dec3d5c28)"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 154.05,
    y: 439.59,
    width: 99.34,
    height: 74.87,
    fill: "#fff"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 446.07,
    width: 33.11,
    height: 18.72,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 446.07,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 453.27,
    width: 27.36,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 204.8,
    y: 460.47,
    width: 38.87,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 467.67,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 474.87,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 482.06,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 489.26,
    width: 73.43,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 496.46,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 163.77,
    y: 503.66,
    width: 79.91,
    height: 4.32,
    fill: "#e6e8ec"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M295.35,598.89l9.31,2L312,602.4l-3.94-11-2.74-.69-4.27-1.06S294.92,559,282.65,561.2,295.35,598.89,295.35,598.89Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#714b4f"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M304.66,600.85,312,602.4l-3.94-11-2.74-.69A43.77,43.77,0,0,0,304.66,600.85Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3,528.78s-10.52,35.5-16.65,39.88-43.38,26.73-54.34,21.47c0,0-2.63,13.15,1.31,16.21,0,0,40.86-1.6,41.19-1.75,0,0,26.73-3.51,31.11-16.65s9.64-35.5,9.64-35.5Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#67647e"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M364.15,471.81s.89,3.43,2.08,8.42a23.65,23.65,0,0,1-26.12,12c1.05-4.5.82-9-2.26-12.57Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 289.16,
    cy: 413.19,
    r: 23.66,
    fill: "#714b4f"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M325.2,461.79a12.67,12.67,0,0,1-5.28.32c-3.69-.76-6.32-4.51-6.41-8.28a12.72,12.72,0,0,1,4.88-9.77c2-1.67,4.4-2.86,6.23-4.72,2.17-2.21,3.35-5.19,5-7.79a23.13,23.13,0,0,1,11.88-9.24c3.63-1.23,8.07-1.37,10.86,1.27,1.43,1.35,2.27,3.3,3.87,4.44,2.32,1.65,5.46,1.16,8.29,1.49a15.8,15.8,0,0,1,11.91,8.92,22.32,22.32,0,0,1,1.16,15.16c-.55,2.15-1.35,4.24-1.94,6.38-1.23,4.46-1.52,9.14-2.94,13.54s-4.35,8.7-8.78,10a27.76,27.76,0,0,0-2.82-14.3,4.1,4.1,0,0,0-2-2.22,4.85,4.85,0,0,0-2.41,0,24,24,0,0,1-16-3.24c-1.68-1-4.3-4.51-6.1-4.86C332.33,458.48,327.6,461.25,325.2,461.79Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M325.2,460.91a12.67,12.67,0,0,1-5.28.32c-3.69-.76-6.32-4.51-6.41-8.28a12.72,12.72,0,0,1,4.88-9.77c2-1.67,4.4-2.86,6.23-4.72,2.17-2.21,3.35-5.19,5-7.79a23.13,23.13,0,0,1,11.88-9.24c3.63-1.23,8.07-1.37,10.86,1.27,1.43,1.35,2.27,3.3,3.87,4.44,2.32,1.65,5.46,1.16,8.29,1.49a15.8,15.8,0,0,1,11.91,8.92,22.32,22.32,0,0,1,1.16,15.16c-.55,2.15-1.35,4.24-1.94,6.38-1.23,4.46-1.52,9.14-2.94,13.54s-4.35,8.7-8.78,10a27.76,27.76,0,0,0-2.82-14.3,4.1,4.1,0,0,0-2-2.22,4.85,4.85,0,0,0-2.41,0,24,24,0,0,1-16-3.24c-1.68-1-4.3-4.51-6.1-4.86C332.33,457.6,327.6,460.38,325.2,460.91Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#503f43"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M142.76,815.41a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82H133.7A40.83,40.83,0,0,0,142.76,815.41Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.76,676.41a11.67,11.67,0,0,0,3.83-5.78c.5-2.3-.48-5.05-2.68-5.89-2.46-.94-5.09.76-7.08,2.49s-4.28,3.69-6.89,3.32a10.48,10.48,0,0,0,3.24-9.81,4.1,4.1,0,0,0-.9-2c-1.37-1.46-3.84-.83-5.48.32-5.2,3.66-6.65,10.72-6.68,17.08-.52-2.29-.08-4.68-.1-7s-.66-5-2.64-6.22a8,8,0,0,0-4-.95c-2.34-.09-4.94.15-6.54,1.86-2,2.12-1.47,5.69.26,8s4.35,3.8,6.77,5.42a15,15,0,0,1,4.84,4.61,4.57,4.57,0,0,1,.36.82h14.65A40.83,40.83,0,0,0,1011.76,676.41Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#009ddd"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.74,375.81c-2.07-6.06-5.06-13.74-7.42-15.55a2.21,2.21,0,0,0-.47-.29h-.29v-7.49l-5.58.89a53.35,53.35,0,0,1-2-8.29,3.85,3.85,0,0,0,4.19.84c-.09-.15-.17-.31-.25-.47l.25-.11a10.37,10.37,0,0,1-1.35-5.08,18.51,18.51,0,0,1,.77-4.8c1-3.45,2.69-6.67,3.63-10.14a24.64,24.64,0,0,0,.84-6.85,25,25,0,0,0-2.6-11.3,6.6,6.6,0,0,0-2-2.58,25.49,25.49,0,0,0-2.42-1.18,13.07,13.07,0,0,1-3.52-3.51,31.56,31.56,0,0,0-15.25-10.18,8.93,8.93,0,0,0-4.88-.39c-3.75,1-5.11,5.65-8.15,8.09-2.68,2.15-6.36,2.37-9.73,3.09s-6.76,2.15-9.06,4.75a9.83,9.83,0,0,0-2.43,6.55,6.59,6.59,0,0,0,2.68,5.86,8.42,8.42,0,0,0,7.11,1,24.18,24.18,0,0,0,18.31,30.4l.65,1.17h0a50.08,50.08,0,0,1,4.54,11.85c-5.14,2.91-10.75,5.64-14.14,5.9a23.82,23.82,0,0,1-.74,3.92,21.62,21.62,0,0,1-4.45,8.75c-4.61,5.18-25.34,44.34-25.34,44.34s-.65,1.56-1.72,4.22c-12.87,1.58-33.88,3.86-39.74,2.69l-23-21.88s-7.44,5.68-6.79,12.58l-4.15-3.94s-21.88,16.7,12.67,27.64l52.57,6.1c-5,15.11-9.68,32.7-8.23,42.27h.43a19.88,19.88,0,0,0,3-.23l-.09,1.7-5.06,90.66s-1.15,16.7,14.4,24.18c0,0,19,55.85,11.52,62.19,0,0,.89.47,2.39,1.12l-15.63,13.85s-11.52,2.88-17.85,2.3a4.57,4.57,0,0,0-5.05,3.4c0,.12,0,.24-.06.36l0,.15c0,.12,0,.24,0,.37s0,.09,0,.14,0,.21,0,.32,0,.09,0,.13,0,.25.07.37l0,.14q.05.2.13.4l.05.12c.05.13.11.26.18.39l0,.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.12.08c.19.12.39.24.6.35l.09,0,.65.32.09,0,.76.3.16.06.83.27.14,0,.91.24.07,0,1,.2.2,0,1.08.16.21,0,1.22.12c2.37.18,5.56.25,9.25.23h0s0,.09,0,.14,0,.21,0,.32l0,.13c0,.12,0,.25.07.37l0,.14q.05.2.13.4l.05.12c.05.13.11.26.18.39l0,.09c.07.13.15.25.23.38l.07.11q.14.2.31.4l.09.1c.12.14.25.27.38.4l.06.05.43.37.09.07c.16.13.34.25.52.37l.13.08c.19.12.39.24.6.35l.09,0,.65.32.09,0,.76.3.16.06.83.27.14,0,.91.24.07,0,1,.2.2,0,1.08.16.21,0,1.22.12c15,1.15,62.76-2.3,62.76-2.3l0-.13v0l0-.17v0c.47-2.23,2.77-15.19-5.39-24.77.24-.25.48-.52.7-.8,0,0-6.33-10.94-2.88-14.4s-17.27-63.34-17.27-63.34-10.94-17.27-4.61-36.85-.58-40.88-.58-40.88,15.1-4.49,15.41-23.08c0-.56,0-1.14,0-1.73a6.11,6.11,0,0,0,1,.06,4.47,4.47,0,0,0,.64,0s-2.88-10.36.58-17.85,10.94-.58,17.85-31.09c5-22.08,9.4-47.48,11.45-59.84A31.51,31.51,0,0,0,1141.74,375.81Zm-131.41,64.77-5.25-5c1.74.72,3.67,1.43,5.83,2.11l19.8,2.3C1021.87,440.81,1013.66,441.25,1010.33,440.59Z",
    transform: "translate(-56.59 -55.12)",
    fill: "url(#48518945-bf04-4db7-b147-76b4ac12eaa6)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.45,437.65s-40.73,5.66-49.22,4l-22.63-21.5s-21.5,16.41,12.45,27.15l63.36,7.35Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#fdc2cc"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M1060.45,437.65s-40.73,5.66-49.22,4l-22.63-21.5s-21.5,16.41,12.45,27.15l63.36,7.35Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.05
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.16,667.33l-19.8,17.54s-11.31,2.83-17.54,2.26-9.05,9.62,5.66,10.75,61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#47465a"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.16,667.33l-19.8,17.54s-11.31,2.83-17.54,2.26-9.05,9.62,5.66,10.75,61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.05
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.85,687.78a31.2,31.2,0,0,1-.71,6.13s-47,3.39-61.66,2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64,2.9,1.92,6.74,10.62,7.41,14.71,1.13,61.66-2.26,61.66-2.26A32.69,32.69,0,0,0,1105.85,687.78Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#fff",
    opacity: 0.3
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M1098.35,346.57s12.45,17.54,7.92,29.42S1130,363.54,1130,363.54s-9.05-15.84-4.53-32.81Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#fdc2cc"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M1095,674.11l-19.8,17.54s-11.31,2.83-17.54,2.26-9.05,9.62,5.66,10.75,61.66-2.26,61.66-2.26,4.53-18.1-9.05-28.29Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#47465a"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.62,670.15c-2.95,3.64-7.11,5-11.46,5.25-9.89.47-20.78-5.25-20.78-5.25,7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07,1.25-22.37,15.84-9.62,12.49,9.58,11.84,9.09a47.6,47.6,0,0,1,1.48,8.83c1.37,20.79-15.06,25.68-15.06,25.68s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S1100.62,670.15,1100.62,670.15Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#565171"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1100.62,670.15c-2.95,3.64-7.11,5-11.46,5.25-9.89.47-20.78-5.25-20.78-5.25,7.35-6.22-11.31-61.1-11.31-61.1-15.27-7.35-14.14-23.76-14.14-23.76l5-89.07,1.25-22.37,15.84-9.62,12.49,9.58,11.84,9.09a47.6,47.6,0,0,1,1.48,8.83c1.37,20.79-15.06,25.68-15.06,25.68s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S1100.62,670.15,1100.62,670.15Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.05
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.42,676.94c-9.62,11.88-32.24,0-32.24,0a3.6,3.6,0,0,0,1-1.54c4.15-11.28-14-65.21-14-65.21-15.27-7.35-17-24.89-17-24.89l-4-90.65-.52-11.74,23.8-9.09,7.31-2.79,24.33,18.67a44.12,44.12,0,0,1,1.56,11.83c-.31,18.27-15.14,22.68-15.14,22.68s6.79,20.93.57,40.16,4.53,36.2,4.53,36.2,20.37,58.83,17,62.23S1120.42,676.94,1120.42,676.94Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#565171"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.66,501.52c-4.89-.7-14.79-6.59-19.88-9.79-1.94-1.22-3.18-2-3.18-2s-5.09-14.14-18.67-3.39a50.82,50.82,0,0,1-14.75,8.34,34.51,34.51,0,0,1-6.3,1.58l1.25-22.37,15.84-9.62,12.49,9.58,7.31-2.79,24.33,18.67A44.12,44.12,0,0,1,1110.66,501.52Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1141.28,393c-2,12.14-6.34,37.09-11.25,58.79-6.79,30-14.14,23.19-17.54,30.55s-.57,17.54-.57,17.54c-5.66.57-24.33-11.88-24.33-11.88s-5.09-14.14-18.67-3.39-24.33,10.18-24.33,10.18c-2.83-18.67,18.1-68.45,18.1-68.45s20.37-38.47,24.89-43.56a21.24,21.24,0,0,0,4.37-8.6,23.4,23.4,0,0,0,.72-3.85c7.35-.57,25.46-13,25.46-13l14.14-2.26v7.35a2.17,2.17,0,0,1,.46.28c2.33,1.78,5.26,9.33,7.29,15.28A31,31,0,0,1,1141.28,393Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f68080"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1130,369.77s-14.71-11.88-36.77,26.59-27.15,32.24-27.15,32.24,4.53,17,2.26,20.37c0,0,15.27-1.13,20.93,0S1130,406,1130,406,1148.14,381.08,1130,369.77Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1129.47,367.5s-14.71-11.88-36.77,26.59-27.15,32.24-27.15,32.24,17.54,19.23,23.19,20.37,40.73-43,40.73-43S1147.57,378.82,1129.47,367.5Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1067.85,445.29c.23-4.19-1.35-11.56-2.26-15.38,3.44-.45,5.61-.75,5.61-.75l4,17Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1126.07,331.87l-27.15,15.84a58,58,0,0,1,3.16,5.18,23.87,23.87,0,0,0,4.76.48c7.25,0,10.63-7.61,15-12.73C1121.53,336.53,1124.86,336.42,1126.07,331.87Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1049.69,
    cy: 273.35,
    r: 23.76,
    fill: "#fdc2cc"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 821.62,
    y: 300.43,
    width: 191.35,
    height: 144.2,
    fill: "url(#dd1dbd67-1519-4b37-9c1d-ca278a6685f4)"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 825.91,
    y: 303.66,
    width: 182.77,
    height: 137.74,
    fill: "#fff"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 315.58,
    width: 60.92,
    height: 34.43,
    fill: "#009ddd",
    opacity: 0.2
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 919.28,
    y: 315.58,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 919.28,
    y: 328.83,
    width: 50.33,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 919.28,
    y: 342.07,
    width: 71.52,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 355.31,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 368.56,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 381.8,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 395.05,
    width: 135.09,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 408.29,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 843.79,
    y: 421.53,
    width: 147.01,
    height: 7.95,
    fill: "#e6e8ec"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.22,309.25a16.24,16.24,0,0,1,8.9-4.67c3.3-.71,6.92-.93,9.56-3,3-2.39,4.32-6.93,8-7.94a8.77,8.77,0,0,1,4.79.38,31,31,0,0,1,15,10,12.84,12.84,0,0,0,3.45,3.45,25,25,0,0,1,2.38,1.16,6.48,6.48,0,0,1,1.94,2.53,24.59,24.59,0,0,1,1.72,17.27c-.92,3.41-2.58,6.57-3.56,10s-1.23,7.24.57,10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21,21,0,0,0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45,1.79-.86,2.61-.81,1.6-3.15,1.92-4.7,1a7.21,7.21,0,0,1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14,1.26-6.84,2.11-9.86-.05C1072.6,318.11,1073.37,312.47,1076.22,309.25Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.1
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1076.22,308.68a16.24,16.24,0,0,1,8.9-4.67c3.3-.71,6.92-.93,9.56-3,3-2.39,4.32-6.93,8-7.94a8.77,8.77,0,0,1,4.79.38,31,31,0,0,1,15,10,12.84,12.84,0,0,0,3.45,3.45,25,25,0,0,1,2.38,1.16,6.48,6.48,0,0,1,1.94,2.53,24.59,24.59,0,0,1,1.72,17.27c-.92,3.41-2.58,6.57-3.56,10s-1.23,7.24.57,10.27c-1.74.89-3.94-.23-5-1.85s-1.42-3.62-2-5.49a21,21,0,0,0-6.13-9.53c-1.78-1.58-5-2.64-6.21-.6-.48.79-.45,1.79-.86,2.61-.81,1.6-3.15,1.92-4.7,1a7.21,7.21,0,0,1-2.94-4.36c-2.33-7.88-6.3-12.84-14.73-9.47-3.14,1.26-6.84,2.11-9.86-.05C1072.6,317.54,1073.37,311.91,1076.22,308.68Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#b96b6b"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1132.76,362.7h-11.5s-22.63,11.31-23.19,10.75c-.38-.38-3.88.27-6.1.74a23.4,23.4,0,0,0,.72-3.85c7.35-.57,25.46-13,25.46-13l14.14-2.26v7.35A2.17,2.17,0,0,1,1132.76,362.7Z",
    transform: "translate(-56.59 -55.12)",
    opacity: 0.05
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1125.65,694.57a31.2,31.2,0,0,1-.71,6.13s-47,3.39-61.66,2.26c-7.07-.54-10.08-3.18-10.62-5.71-.64,2.9,1.92,6.74,10.62,7.41,14.71,1.13,61.66-2.26,61.66-2.26A32.69,32.69,0,0,0,1125.65,694.57Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#fff",
    opacity: 0.3
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.05
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1063.56,484c-7.63,6-14.38,8.51-18.81,9.51,0,.42.08.84.14,1.24,0,0,10.75.57,24.33-10.18a18.23,18.23,0,0,1,7.27-3.8C1073.53,479.4,1069.3,479.49,1063.56,484Z",
    transform: "translate(-56.59 -55.12)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1140.34,378c-2-6-5-13.5-7.29-15.28a2.17,2.17,0,0,0-.46-.28s-4.68.16-4.53.28c2.33,1.78,4.59,8.76,6.62,14.71a31,31,0,0,1,1.23,15c-2,12.14-6.34,37.09-11.25,58.79-6.79,30-14.14,23.19-17.54,30.55-2.78,6-1.39,13.94-.79,16.61,2.42,1,4.52,1.63,5.88,1.49,0,0-2.83-10.18.57-17.54s10.75-.57,17.54-30.55c4.91-21.69,9.23-46.65,11.25-58.79A31,31,0,0,0,1140.34,378Z",
    transform: "translate(-56.59 -55.12)"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.16,446.14l-7.31-.85-56-6.51c-33.94-10.75-12.45-27.15-12.45-27.15l22.63,21.5c6.53,1.31,32.13-1.74,43.6-3.21,3.44-.45,5.61-.75,5.61-.75Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#fdc2cc"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M1130,368.64s-14.71-11.88-36.77,26.59-27.15,32.24-27.15,32.24,4.53,17,2.26,20.37c0,0,15.27-1.13,20.93,0s40.73-43,40.73-43S1148.14,379.95,1130,368.64Z",
    transform: "translate(-56.59 -55.12)",
    fill: "#f68080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileTabLaptop);
export default __webpack_public_path__ + "static/media/mobile-tab-laptop.3175f1aa5e8dd112beca3dfdc1014ed8.svg";
export { ForwardRef as ReactComponent };